<template>
    <!--支付方式-->
    <div>
        <el-dialog title="在线支付"
                   :visible.sync="showPayment"
                   :before-close='closeDialog'
                   width="30%"
                   :center="false"
                   top="15vh"
                   :close-on-click-modal="false"
                   :append-to-body="true">
            <el-row>
                <el-col :span="24" align="center">
                    <el-radio-group v-model="paymentWay" @change="handleChangeWay">
                        <el-radio :label="'11'" v-if="showWechatPay">
                            <template>
                                <img class="img-icon"
                                     :src="require('../../assets/imgs/wxpay.png')">
                            </template>
                        </el-radio>
                        <el-radio :label="'10'">
                            <template>
                                <img class="img-icon"
                                     :src="require('../../assets/imgs/alipay.png')">
                            </template>
                        </el-radio>
                    </el-radio-group>
                </el-col>
            </el-row>
            <el-row>
                <el-col v-if="payQRUrl == '' && paymentWay != ''">
                    <el-button :type="paymentWay == 11 ? 'success' : 'primary'"
                               style="width: 100%"
                               @click="confirmPay()"
                               :loading="confirmLoading">
                        确认支付{{payData.totalMoney}}元
                    </el-button>
                </el-col>
                <el-col v-if="payQRUrl != ''" align="center">
                    <div style="position:relative; width:298px; height:298px">
                        <img :src="payQRUrl" width="298px" height="298px" style="border:1px solid #CCCCCC" />
                        <div class="mask" v-if="isPayComplate">
                            <img :src="require('@/assets/imgs/pay_success.png')" width="100px" height="100px" />
                            <br>
                            <span style="color:black">支付成功</span>
                        </div>
                    </div>
                    <div style="margin:2px 0 5px 0; padding:10px 0; width:300px; background-color:gray;color:white">
                        <p>请使用{{paymentWay == "11" ? "微信" : "支付宝"}}扫一扫</p>
                        <p>扫描上方二维码支付</p>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="isShowComlateBtn">
                <el-col align="center">
                    <el-button ref="btnComplete" type="danger" style="width: 300px" :disabled=complateBtnDisabled @click="complatePay()" :loading="complateLoading">
                        <span v-if="!isCanClickComplateBtn">请在{{second}}秒内完成支付</span>
                        <span v-else>我已完成支付?</span>
                    </el-button>
                </el-col>
            </el-row>
            <div style="padding:10px; color:red; text-align: left;">
                因微信虚拟交易额度限制，单笔金额超6000元的，请使用支付宝支付。
            </div>
        </el-dialog>
    </div>
</template>
<style style='scss' scoped>
    .img-icon {
        width: 150px;
        height: 40px;
        margin-left: -15px;
    }

    .el-radio {
        margin-right: 20px;
    }

    .el-radio:last-child {
        margin-right: 0px;
    }

    .el-radio /deep/ .el-radio__input {
        padding-bottom: 30px;
    }

    .el-radio-group {
        margin-left: 20px;
    }

    .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 298px;
        height: 298px;
        background: rgba(246, 246, 246, 0.9);
        color: #ffffff;
        opacity: 0.9;
    }

    .mask img {
        margin-top: 99px;
    }
</style>

<script>
import {  post } from '@/api/common/index'
import QRCode from 'qrcode'
export default {
  data () {
    return {
      confirmLoading: false,
      complateLoading: false,
      payData: '', // 待付款实体
      paymentWay: '',
      showPayment: true,
      orderNo: '',     // 微信或支付宝订单号
      payQRUrl: '',    // 微信或支付宝二维码
      timer:null,      // 定时器
      second:120,      // 倒计时（2分钟内）
      isShowComlateBtn: false,
      isCanClickComplateBtn: false, // 超过120秒后，显示我已完成支付按钮
      complateBtnDisabled:true,
      isPayComplate: false, // 是否支付完成
      showWechatPay:true,
    }
  },
  mounted () {
    this.init();
  },
  methods: {
      // 确认支付
    confirmPay () {
      //var vm = this
      this.confirmLoading = true
      // // 如果已经生成过订单号，先询问是否要先关闭（未支付）
      // if(vm.payData.orderNo || vm.orderNo){
      //   this.$confirm('已生成过订单，是否要关闭原订单重新发起支付?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.genarateOrder();
      //   }).catch(() => {
      //     this.confirmLoading = false
      //   });
      // }
      // else{
      //   this.genarateOrder();
      // }

      this.genarateOrder();
    },
    genarateOrder(){
      var vm = this

      var para = {
        feeIdList : vm.payData.rentalIDs.replace(/,/g, '|'),
        feeType : vm.payData.feeType,
        payedType: vm.paymentWay
      };

      // 获取支付二维护码链接
      post('/api/pay/get_pay_qrcode_url', para)
      .then(res => {
        if (res.success) {
          if(res.data.url == ""){
            this.$message({message: "二维码生成失败，请重试",type: 'error'})
          }else{
            this.orderNo = res.data.outTradeNo;
            QRCode.toDataURL(decodeURIComponent(res.data.url))
            .then(url => {
              vm.payQRUrl = url
              vm.isShowComlateBtn = true;
              // 出现二维码后，初始化计时器轮询（3 秒一次请求支付状态）
              this.timer = setInterval(() => {
                 this.second--;
                  if(this.second <= 0){
                     this.isCanClickComplateBtn = true;
                     this.complateBtnDisabled = false;
                     clearInterval(this.timer);
                  }

                 if(this.second % 3 === 0){
                    this.getPayStatus();
                 }
              }, 1000);
            })
          }
        } else {
          this.$message({message: res.reason,type: 'error'})
          this.confirmLoading = false
        }
      }
      ,err=>{
        this.$message({message: err,type: 'error'})
        this.confirmLoading = false
      }
      ).catch(error => {
        this.$message({message: error,type: 'error'})
        this.confirmLoading = false
      })
    },
    // 获取支付状态
    getPayStatus(){
      var vm = this;
      vm.timerNum++;
      // 调用接口查询订单状态，一旦支付成功，页面自动回转
      post('/api/pay/query_qrcode_pay_status',{orderNo: vm.orderNo, payedType: vm.paymentWay})
      .then(res=>{
        if(res.data && res.data == true){
          if(this.timer){
            // 清除定时器
            clearInterval(this.timer);
          }

          this.isPayComplate = true;

          setTimeout(() => {
            this.closeDialog();
          }, 2000);
        }
      }).catch(()=>{
          // 错误不管
      });
    },
    // 手动点按钮支付完成
    complatePay () {
        var vm = this;
        this.complateLoading = true;

        // 调用接口查询订单状态，一旦支付成功，页面自动回转
        post('/api/pay/query_qrcode_pay_status',{orderNo: vm.orderNo, payedType: vm.paymentWay})
        .then(res=>{
          if(res.data && res.data == true){
            if(this.timer){
              // 清除定时器
              clearInterval(this.timer);
            }

            this.isPayComplate = true;
            setTimeout(() => {
              this.closeDialog();
            }, 2000);
          }
          else{
            this.$message({message: "订单未支付",type: 'error'})
            this.complateLoading = false;
          }
        },err=>{
          this.$message({message: err,type: 'error'})
          this.complateLoading = false;
        }).catch(()=>{
          this.$message({message: "获取支付结果失败，请重试",type: 'error'})
          this.complateLoading = false;
        });
    },
    handleChangeWay () {
      this.second = 120
      this.payQRUrl = ''
      this.confirmLoading = false
      this.complateLoading = false
      //this.orderNo = ""

      this.timerNum = 0
      this.isPayComplate = false
      this.isShowComlateBtn = false
      this.isCanClickComplateBtn = false
      this.complateBtnDisabled = true

      if(this.timer){
        clearInterval(this.timer);
      }
    },
    init(){
      this.second = 120
      this.payData = ''
      this.payQRUrl = ''
      this.paymentWay = ''
      this.showPayment = false
      this.confirmLoading = false
      this.complateLoading = false
      this.orderNo = ""
      this.timer = null
      this.timerNum = 0
      this.isPayComplate = false
      this.isShowComlateBtn = false
      this.isCanClickComplateBtn = false
      this.complateBtnDisabled = true
    },
    closeDialog () {
      if(this.timer){
        clearInterval(this.timer);
      }

      this.init();
      this.$emit('refreshDataList')
    }
  },
  watch:{
    payData: function(newData, oldData){
      this.showWechatPay = true;
      if(newData != oldData && newData){
        if(newData.needMoney >= 6000){
          this.showWechatPay = false;
        }
      }
    }
  }
}
</script>
